module.exports = __webpack_public_path__ + "img/hero-04.60bbc296.jpg";